// src/components/Header.js
import React, { useState, useEffect } from 'react';
import {
  FaWhatsapp,
  FaBars,
  FaTimes,
  FaFacebookF,
  FaInstagram,
  FaGoogle,
  FaCrown,
} from 'react-icons/fa';
import '../css/Header.css';
import BookingModal from './BookingModal';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activePath, setActivePath] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setActivePath(window.location.pathname);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const getNavLinkClass = (path) => {
    return `nav-item ${activePath === path ? 'active' : ''}`;
  };

  return (
    <header className="main-header">
      {/* Top Info Bar */}
      <div className="top-info-bar">
        <div className="top-info-container">
          {/* Left: Call Info */}
          <div className="top-left">
            <span className="info-text">
              CALL US :{' '}
              <a href="tel:+918879779777" className="info-link">
                +91 8879779777
              </a>
            </span>
          </div>

          {/* Center: Social Icons */}
          <div className="top-center">
            <a
              href="https://www.facebook.com/profile.php?id=61579151297192"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/no_brokerage_payingguest/"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://share.google/fPIgRUSA8uh983Pv4"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
              aria-label="Google"
            >
              <FaGoogle />
            </a>
          </div>

          {/* Right: Mail Info */}
          <div className="top-right">
            <span className="info-text">
              MAIL US :{' '}
              <a href="mailto:swetarita25786@gmail.com" className="info-link">
                swetarita25786@gmail.com
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Main Header Bar */}
      <div className="header-container">
        <a href="/" className="brand-logo" onClick={closeMobileMenu}>
          <div className="logo-wrapper">
            {/* <FaCrown className="logo-icon" /> */}
            <span className="logo-text">No Brokerage Paying Guest</span>
            <span className="logo-badge">LUXURY</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="main-nav desktop-nav">
          <ul className="nav-list">
            <li><a href="/" className={getNavLinkClass('/')}>Home</a></li>
            <li><a href="/properties" className={getNavLinkClass('/properties')}>Properties</a></li>
            <li><a href="/about" className={getNavLinkClass('/about')}>About</a></li>
            <li><a href="/gallery" className={getNavLinkClass('/gallery')}>Gallery</a></li>
            <li><a href="/faq" className={getNavLinkClass('/faq')}>FAQs</a></li>
            <li><a href="/SaffronHabitat" className={getNavLinkClass('/SaffronHabitat')}>Saffron Habitat</a></li>
            <li><a href="/blog" className={getNavLinkClass('/blog')}>Blogs</a></li>
            <li><a href="/contact" className={getNavLinkClass('/contact')}>Contact</a></li>
          </ul>
          <div className="right-section">
            <button className="book-now-btn" onClick={() => setShowModal(true)}>
              Book Now
            </button>
          </div>
        </nav>

        {/* Mobile Hamburger */}
        <button className="menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle navigation">
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo-wrapper">
            {/* <FaCrown className="sidebar-logo-icon" /> */}
            <a href="/" className="sidebar-logo" onClick={closeMobileMenu}>
              No Brokerage Paying Guest<span> </span>
            <span className="sidebar-badge">LUXURY</span>
            </a>
            
          </div>
          <button className="sidebar-close" onClick={closeMobileMenu}>
            <FaTimes />
          </button>
        </div>
        <nav className="sidebar-nav">
          <ul className="sidebar-nav-list">
            <li><a href="/" className={getNavLinkClass('/')} onClick={closeMobileMenu}>Home</a></li>
            <li><a href="/properties" className={getNavLinkClass('/properties')} onClick={closeMobileMenu}>Properties</a></li>
            <li><a href="/about" className={getNavLinkClass('/about')} onClick={closeMobileMenu}>About</a></li>
            <li><a href="/gallery" className={getNavLinkClass('/gallery')} onClick={closeMobileMenu}>Gallery</a></li>
            <li><a href="/faq" className={getNavLinkClass('/faq')} onClick={closeMobileMenu}>FAQs</a></li>
            <li><a href="/SaffronHabitat" className={getNavLinkClass('/SaffronHabitat')} onClick={closeMobileMenu}>Saffron Habitat</a></li>
            <li><a href="/blog" className={getNavLinkClass('/blog')} onClick={closeMobileMenu}>Blogs</a></li>
            <li><a href="/contact" className={getNavLinkClass('/contact')} onClick={closeMobileMenu}>Contact</a></li>
          </ul>
          <div className="sidebar-contact">
            <a href="https://wa.me/918879779777" target="_blank" rel="noopener noreferrer" className="sidebar-whatsapp">
              <FaWhatsapp /> +91 8879779777
            </a>
            <button className="book-now-btn sidebar-book-btn" onClick={() => { setShowModal(true); closeMobileMenu(); }}>
              Book Now
            </button>
          </div>
        </nav>
      </div>

      {/* Backdrop overlay */}
      {isMobileMenuOpen && <div className="sidebar-backdrop" onClick={closeMobileMenu}></div>}

      {showModal && <BookingModal onClose={() => setShowModal(false)} />}
    </header>
  );
};

export default Header;